import React from 'react';
import { IoClose } from 'react-icons/io5';

interface FlyoutHeaderProps {
  title: string;
  closeLabel: string;
  onClose: () => void;
}

/** Step picker flyout title with a close (✕) button on the right; same as Escape / Left. */
const FlyoutHeader: React.FC<FlyoutHeaderProps> = ({
  title,
  closeLabel,
  onClose,
}) => (
  <div className="flex items-center justify-between gap-2 border-b p-3 text-base font-semibold text-charcoal">
    <span className="min-w-0 truncate">{title}</span>
    <button
      type="button"
      className="flex flex-shrink-0 items-center justify-center rounded-[var(--radius-button)] p-1 text-gray-dark hover:bg-gray-smoke"
      aria-label={closeLabel}
      onClick={onClose}
    >
      <IoClose size={16} aria-hidden="true" />
    </button>
  </div>
);

export default FlyoutHeader;
